import { useContext } from 'react'
import { ZoneResults } from 'shared-ui'
import GridModeContext from '../../context/GridMode'
import PitchTelemetry from '../../context/covermaster/PitchTelemetry'
import UnitSystemContext from '../../context/UnitSystem'

export default function ZoneResultsWithContext({
    gridId,
    backgroundType,
    zoneResults = [],
    isPercentageTemplate = false,
    decimals,
    getZoneBackendColor,
    enableClicks = false,
    onClickZone,
    unitSI,
    underLay,
    ...props
}) {

    const { selectedPosition } = useContext(PitchTelemetry) ?? {}
    const { unitSystem } = useContext(UnitSystemContext)
    const { selectedMode } = useContext(GridModeContext)

    return <ZoneResults
        gridId={gridId}
        backgroundType={backgroundType}
        zoneResults={zoneResults}
        isPercentageTemplate={isPercentageTemplate}
        decimals={decimals}
        getZoneBackendColor={getZoneBackendColor}
        enableClicks={enableClicks}
        onClickZone={onClickZone}
        unitSI={unitSI}
        underLay={underLay}
        selectedMode={selectedMode}
        selectedPosition={selectedPosition}
        unitSystem={unitSystem}
        {...props}
    />
}